import { render } from "./perbaikan-form.vue?vue&type=template&id=41bedcd4&scoped=true"
import script from "./perbaikan-form.vue?vue&type=script&lang=js"
export * from "./perbaikan-form.vue?vue&type=script&lang=js"

import "./perbaikan-form.vue?vue&type=style&index=0&id=41bedcd4&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bedcd4"]])

export default __exports__